module.exports = __webpack_public_path__ + "media/svg-new/svg-settings-49c0f937.svg";